import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import Typewriter from "typewriter-effect";
import { getCommunityDevelopmentList } from "components/Service/CommunityDevelopLink";
import { API_BASE_CMS, API_BASE_IMG_URl } from "helper/environment";
import TypedText from "components/Homes/typewrite";

const CommDevelDetail: React.FC = () => {
const [data, setdata] = useState<any | null>(null);
const [loading, setLoading] = useState(true);
const location = useLocation();

 const { title } = useParams(); // get id from URL
   useEffect(() => {
      const fetchData = async () => {
        const data = await getCommunityDevelopmentList();
  
        const filtered = (data || [])
          .filter(
            (item: any) =>
              item.path === '/'+ title); // DESC order
  
        setdata(filtered[0]);
      };
  
      fetchData();
    }, []);
const [display, setDisplay] = useState("");

useEffect(() => {
  const el = document.createElement("textarea");
  el.innerHTML = data?.title || "";
  const decoded = el.value;

  let i = 0;
  const interval = setInterval(() => {
    setDisplay(decoded.slice(0, i + 1));
    i++;
    if (i >= decoded.length) clearInterval(interval);
  }, 50);

  return () => clearInterval(interval);
}, [data?.title]);
if (!data) return null;
const path = location.pathname;
const newPath = path.substring(0, path.lastIndexOf('/'));

//console.log(newPath);
//console.log(data);

const newsbutton  = localStorage.getItem("cmbutton") || "Back To List Page";
return(

  <div id="section-communitylist-detail">
        <div className="container py-2">
            <nav aria-label="breadcrumb animated slideInDown ">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a className="text-dark" href="/">Home</a></li>
                    <li className="breadcrumb-item"><Link className="text-dark" to={newPath}>Community Development</Link></li>
                      <li className="breadcrumb-item"><a className="text-dark" href={location.pathname}>{data?.title}</a></li>
                </ol>
            </nav>
        </div>
        <div id="section" className="media ">
            <div className="container">
   
                <div >
                    <Link to={newPath} className="text-black d-flex align-content-end"> <i className="la la-long-arrow-left text-primary pe-2" style={{fontSize:'18px'}}></i>{newsbutton}</Link>
                    <hr />
                </div>
                <div className="section-title  text-left mx-auto my-4 wow fadeInUp clearfix" data-wow-delay="0.1s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}>
                   
                    <h2 className="mb-0 text-center"  >
                      {data?.title}
                      </h2>
           
         
                    <p className="mx-auto d-none" dangerouslySetInnerHTML={{
                            __html: data?.short_description || "",
                        }} />
                        

                </div>
                <div className="row g-0">
                    {data?.detail_image?.url && (
                    <div className="col-sm-12 mb-3 wow d-none fadeInUp">
                         <img src={data?.detail_image?.url} alt={data?.detail_image?.alt} loading="lazy" className="img-fluid rounded-4 " />
                    </div>
                    )}
                   {data?.description && (
                    <div
                      className="col-sm-12  wow fadeInUp" data-wow-delay="0.5s" style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}
                      dangerouslySetInnerHTML={{
                        __html: data.description,
                      }}
                    />
                  )}

                </div>
           

            </div>
        </div>
  </div>

);
};
export default CommDevelDetail;